<template>
  <Wrapper
    id="stream-accounts-edit"
    :header="$t('_web_profile-edit_streaming-accounts', 'Streaming')"
    :join="join"
  >
    <SocialsGroup v-model="accountSocials" v-bind="{ columns, items }" />
  </Wrapper>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Wrapper from '../../PanelWrapper';
import SocialsGroup from '@/components/form/SocialsGroup';
import { prop } from '@/utils/factories';

export default {
  name: 'AccountEditStreams',
  components: {
    SocialsGroup,
    Wrapper,
  },
  props: {
    join: prop(String),
    columns: prop(Number, 1),
  },
  data() {
    return {
      items: [
        // { id: 'telegram', title: 'Telegram' },
        { id: 'youtube', title: 'Youtube' },
        { id: 'twitch', title: 'Twitch' },
      ],
    };
  },
  computed: {
    ...mapGetters(['accountEditData']),
    accountSocials: {
      get() {
        return this.accountEditData.streams || {};
      },
      set(streams) {
        this.updateEditData({
          social: {
            ...this.accountEditData.social,
            ...streams,
          },
          streams,
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateEditData']),
  },
};
</script>
